import React from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { Mic } from 'lucide-react';
import CollectionDetailAdmin from '../CollectionDetailAdmin';

const CuratorCollectionDetail = () => {
  const params = useParams();
  const location = useLocation();
  
  console.log('CuratorCollectionDetail: All params:', params);
  console.log('CuratorCollectionDetail: Location pathname:', location.pathname);
  
  const pathParts = location.pathname.split('/');
  const collectionsIndex = pathParts.findIndex(part => part === 'collections');
  const collectionIdFromPath = collectionsIndex !== -1 ? pathParts[collectionsIndex + 1] : null;
  
  const collectionId = params.collectionId || collectionIdFromPath;
  
  console.log('CuratorCollectionDetail: Final collectionId:', collectionId);
  
  if (!collectionId) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Error Loading Collection</h2>
        <p>Invalid collection ID</p>
        <p>Debug: pathname = {location.pathname}</p>
        <p>Debug: params = {JSON.stringify(params)}</p>
        <button onClick={() => window.history.back()}>Go Back</button>
      </div>
    );
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0.5rem 1rem 0' }}>
        <Link
          to={`/curator/collections/${collectionId}/tour`}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '6px 12px',
            background: '#4338ca',
            color: '#fff',
            borderRadius: 4,
            textDecoration: 'none',
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          <Mic size={14} /> Edit Tour
        </Link>
      </div>
      <CollectionDetailAdmin />
    </>
  );
};

export default CuratorCollectionDetail;
